<template>
  <div class="container content-block reset-password mt-5">
    <template v-if="passwordUpdated">
      <h3>Wachtwoord gewijzigd</h3>
      <p class="mt-4">
        Je wachtwoord is gewijzigd. Je kan vanaf nu aanmelden met je nieuw wachtwoord.
      </p>
      <router-link class="btn btn-sandpiper btn-block mt-5" to="/login">Aanmelden</router-link>
    </template>
    <template v-else>
      <h3>Wachtwoord wijzigen</h3>
      <form class="reset-password-form" @submit.prevent="resetPassword">
        <div class="form-group">
          <label for="new-password">Wachtwoord <small>(min. 8 tekens, 1 hoofdletter, 1 cijfer, 1 teken)</small></label>
          <input id="new-password" type="password" class="form-control" v-model="newPassword"
                 autocomplete="new-password">
        </div>
        <div class="form-group">
          <label for="new-password-repeated">Wachtwoord bevestigen</label>
          <input id="new-password-repeated" type="password" class="form-control" v-model="newPasswordRepeated"
                 autocomplete="new-password">
        </div>
        <div class="form-feedback" v-if="formFeedback">
          {{ formFeedback }}
        </div>

        <button class="btn btn-sandpiper btn-block mt-4" :class="[updatingPassword? 'disabled' : '']"
                :disabled="updatingPassword" type="submit">
          Wachtwoord wijzigen
        </button>
      </form>
    </template>
  </div>
</template>

<script>
import log from "@/utils/logger";
import { AuthApi } from "sandpiper_api";

export default {
  name: "ResetPassword",
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      updatingPassword: false,
      passwordUpdated: false,
      newPassword: '',
      newPasswordRepeated: '',
      passwordResetCode: null,
      userId: null,

      formFeedback: null
    }
  },
  methods: {
    fetchQueryParams()
    {
      this.userId = this.$route.query.userId ? parseInt(this.$route.query.userId) : null;
      this.passwordResetCode = this.$route.query["reset-code"] || null;

      log.debug("Fetched query params:\nuserId: %s\npasswordResetCode: %s", this.userId, this.passwordResetCode);
    },
    async resetPassword()
    {
      try
      {
        log.info("Trying to activate account for user [%s] with activation code [%s]", this.userId, this.activationCode);

        this.updatingPassword = true;

        await this.doApiRequest(() => new AuthApi().resetPassword({
          userId: this.userId,
          resetCode: this.passwordResetCode,
          newPassword: this.newPassword
        }));

        this.passwordUpdated = true;
      }
      catch (e)
      {
        // TODO - handle error, show correct message
      }
      finally
      {
        this.updatingPassword = false;
      }
    }
  },
  created()
  {
    this.fetchQueryParams();

    if (this.passwordResetCode === "dev-test" && this.userId === 1)
    {
      setTimeout(() => this.passwordUpdated = true, 3000);
    }
    else if (this.passwordResetCode === null || this.userId === null)
    {
      this.$router.replace({ name: 'login' });
    }
  }
}
</script>

<style lang="scss" scoped>
.content-block
{
  padding: 25px;
}

.reset-password
{
  max-width: 400px;

  h3
  {
    font-size: 20px;
    font-weight: bold;
  }

  label
  {
    font-weight: bold;
  }
}

.reset-password-form
{
  margin-top: 20px;
}
</style>